module.exports = __webpack_public_path__ + "img/135.2.e9de8f6e.png";